/* ===========================================
   DULET INTERNATIONAL GROUP — JAVASCRIPT
   =========================================== */

'use strict';

// ---- 1. PARTICLE SYSTEM ----
(function initParticles() {
    const container = document.getElementById('particles-container');
    if (!container) return;
    for (let i = 0; i < 50; i++) {
        const p = document.createElement('div');
        p.className = 'particle';
        p.style.left = Math.random() * 100 + '%';
        p.style.top = Math.random() * 100 + '%';
        p.style.width = (2 + Math.random() * 3) + 'px';
        p.style.height = p.style.width;
        p.style.animationDelay = Math.random() * 20 + 's';
        p.style.animationDuration = (14 + Math.random() * 12) + 's';
        container.appendChild(p);
    }
})();

// ---- 2. NAVBAR SCROLL ----
(function initNavbar() {
    const navbar = document.getElementById('navbar');
    if (!navbar) return;
    const onScroll = () => navbar.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
})();

// ---- 3. MOBILE MENU ----
(function initMobileMenu() {
    // MOBILE MENU HANDLED BY PURE CSS CHECKBOX HACK
    // (See HTML for #mobile-menu-cb and CSS for .mobile-menu-cb:checked)
})();

// ---- 4. SMOOTH SCROLL (REMOVED) ----
// Replaced by native CSS `scroll-behavior: smooth` and `scroll-margin-top: 80px`.

// ---- 5. ANIMATED COUNTER ----
function animateCounter(element, target, duration) {
    duration = duration || 1800;
    const start = performance.now();
    const update = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // Ease out
        const eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = Math.round(eased * target);
        if (progress < 1) requestAnimationFrame(update);
        else element.textContent = target;
    };
    requestAnimationFrame(update);
}

// ---- 6. INTERSECTION OBSERVER ----
(function initObservers() {
    // Reveal cards
    const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
                const delay = parseInt(entry.target.dataset.delay || 0);
                setTimeout(() => entry.target.classList.add('visible'), delay);
                revealObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.08, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.reveal-card').forEach((card, i) => {
        card.dataset.delay = (i % 4) * 120;
        revealObserver.observe(card);
    });

    // Counters
    const counterObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const target = parseInt(el.dataset.target);
                if (!isNaN(target)) animateCounter(el, target);
                counterObserver.unobserve(el);
            }
        });
    }, { threshold: 0.5 });

    document.querySelectorAll('.counter').forEach(el => counterObserver.observe(el));
})();

// ---- 7. FLIP CARDS (Mobile tap support) ----
(function initFlipCards() {
    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    document.querySelectorAll('.producto-card, .service-card-flip').forEach(card => {
        card.addEventListener('click', () => {
            if (isMobile()) card.classList.toggle('flipped');
        });
    });
})();

// ---- 8. PARALLAX BACKGROUND ----
(function initParallax() {
    const heroGrad = document.querySelector('.hero-bg-gradient');
    if (!heroGrad) return;
    const onScroll = () => {
        if (window.scrollY < window.innerHeight) {
            heroGrad.style.transform = `translateY(${window.scrollY * 0.25}px)`;
        }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
})();

// ---- 9. CONTACT FORM ----
(function initContactForm() {
    const form = document.getElementById('contactForm');
    const toast = document.getElementById('successToast');
    const btn = document.getElementById('submitBtn') || form?.querySelector('button[type="submit"]');
    if (!form || !btn) return;

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // Loading state
        btn.textContent = '⏳ Enviando...';
        btn.disabled = true;

        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        try {
            const response = await fetch('https://n8n.duletias3rver.com/webhook/18be38e4-e117-4273-b632-e6c1816163cb', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                // Show toast
                if (toast) {
                    toast.classList.add('show');
                    setTimeout(() => toast.classList.remove('show'), 4000);
                }
                form.reset();
            } else {
                alert('Hubo un error al enviar tu solicitud. Inténtalo de nuevo.');
            }
        } catch (error) {
            console.error('Error al enviar el formulario:', error);
            alert('Error de conexión. Inténtalo de nuevo más tarde.');
        } finally {
            btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2L15 22 11 13 2 9l20-7z"/></svg> Enviar Solicitud`;
            btn.disabled = false;
        }
    });
})();

// ---- 10. ACTIVE NAV LINK HIGHLIGHT ----
(function initActiveNav() {
    const sections = document.querySelectorAll('section[id]');
    const links = document.querySelectorAll('.nav-link');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                links.forEach(link => {
                    link.style.color = '';
                    link.style.background = '';
                });
                const activeLink = document.querySelector(`.nav-link[href="#${entry.target.id}"]`);
                if (activeLink) {
                    activeLink.style.color = 'var(--blue-300)';
                    activeLink.style.background = 'rgba(29,78,216,0.1)';
                }
            }
        });
    }, { threshold: 0.4 });

    sections.forEach(s => observer.observe(s));
})();

// ---- 11. CURSOR GLOW EFFECT (Desktop) ----
(function initCursorGlow() {
    if (window.matchMedia('(max-width:768px)').matches) return;
    const glow = document.createElement('div');
    glow.style.cssText = `
    position:fixed; pointer-events:none; z-index:9999; transition: opacity 0.3s;
    width:400px; height:400px; border-radius:50%; top:0; left:0;
    background: radial-gradient(circle, rgba(29,78,216,0.06) 0%, transparent 60%);
    transform: translate(-50%,-50%);
  `;
    document.body.appendChild(glow);

    window.addEventListener('mousemove', (e) => {
        glow.style.left = e.clientX + 'px';
        glow.style.top = e.clientY + 'px';
    }, { passive: true });
})();

// ---- 12. EVOLUTION LINK STEPS STAGGER ----
(function initStepItems() {
    const stepsObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const steps = entry.target.querySelectorAll('.step-item');
                steps.forEach((step, i) => {
                    step.style.opacity = '0';
                    step.style.transform = 'translateX(-30px)';
                    setTimeout(() => {
                        step.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
                        step.style.opacity = '1';
                        step.style.transform = 'translateX(0)';
                    }, i * 150);
                });
                stepsObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });

    const evolutionSection = document.getElementById('evolution');
    if (evolutionSection) stepsObserver.observe(evolutionSection);
})();

// ============================================================
// 13. ÚNETE AHORA MODAL
// ============================================================
let _uneteStep = 1;
let _firmaCtx = null;
let _firmaDibujando = false;
let _firmaVacia = true;

function openUneteModal() {
    document.getElementById('uneteOverlay')?.classList.add('open');
    document.getElementById('uneteModal')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    // Close mobile menu if open
    document.getElementById('mobileMenu')?.classList.remove('open');
    // Reset to step 1
    _uneteStep = 1;
    _updateUneteUI();
}

function closeUneteModal() {
    document.getElementById('uneteOverlay')?.classList.remove('open');
    document.getElementById('uneteModal')?.classList.remove('open');
    document.body.style.overflow = '';
}

function _updateUneteUI() {
    // Steps visibility
    for (let i = 1; i <= 3; i++) {
        const el = document.getElementById('uneteStep' + i);
        if (el) el.style.display = (i === _uneteStep) ? 'block' : 'none';
    }
    // Progress steps
    document.querySelectorAll('.unete-progress-step').forEach(s => {
        const step = parseInt(s.dataset.step);
        s.classList.remove('active', 'done');
        if (step < _uneteStep) s.classList.add('done');
        else if (step === _uneteStep) s.classList.add('active');
    });
    // Progress fills
    const fills = document.querySelectorAll('.unete-progress-fill');
    if (fills[0]) fills[0].style.width = _uneteStep >= 2 ? '100%' : '0';
    if (fills[1]) fills[1].style.width = _uneteStep >= 3 ? '100%' : '0';
    // Scroll modal to top
    const modal = document.getElementById('uneteModal');
    if (modal) modal.scrollTop = 0;
}

function uneteNext(from) {
    if (from === 1) {
        // Validate step 1
        const nombre = document.getElementById('unNombre')?.value.trim();
        const email = document.getElementById('unEmail')?.value.trim();
        const tel = document.getElementById('unTel')?.value.trim();
        const ciudad = document.getElementById('unCiudad')?.value.trim();
        if (!nombre || !email || !tel || !ciudad) {
            alert('Por favor completa todos los campos obligatorios (*).');
            return;
        }
        if (!email.includes('@') || !email.includes('.')) {
            alert('Ingresa un correo electrónico válido.');
            return;
        }
        const telDigits = tel.replace(/\D/g, '');
        if (telDigits.length < 10) {
            alert('Ingresa un número de teléfono válido (mínimo 10 dígitos).');
            return;
        }
        // Fill contract
        const pais = document.getElementById('unPais')?.value || 'México';
        const hoy = new Date();
        const fechaStr = hoy.toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' });
        const fEl = document.getElementById('contratoFecha');
        const nEl = document.getElementById('contratoNombre');
        const cEl = document.getElementById('contratoCiudad');
        const pEl = document.getElementById('contratoPais');
        if (fEl) fEl.textContent = fechaStr;
        if (nEl) nEl.textContent = nombre;
        if (cEl) cEl.textContent = ciudad;
        if (pEl) pEl.textContent = pais;
        _uneteStep = 2;
        _updateUneteUI();
        // Init canvas AFTER step 2 is visible so getBoundingClientRect has real dimensions
        requestAnimationFrame(() => _initFirmaCanvas());
    } else if (from === 2) {
        // Validate step 2
        const acepto = document.getElementById('uneteAcepto')?.checked;
        if (!acepto) { alert('Debes aceptar las cláusulas del contrato.'); return; }
        if (_firmaVacia) { alert('Por favor dibuja tu firma digital.'); return; }
        
        // Move to step 3 and show spinner
        _uneteStep = 3;
        _updateUneteUI();
        document.getElementById('uneteSpinner').style.display = 'block';
        document.getElementById('uneteResultOk').style.display = 'none';
        document.getElementById('uneteResultError').style.display = 'none';
        
        // Collect form data
        const canvas = document.getElementById('uneteFirmaCanvas');
        const firmaBase64 = canvas ? canvas.toDataURL('image/png') : '';
        
        const nombreVal = document.getElementById('unNombre')?.value.trim() || '';
        const emailVal = document.getElementById('unEmail')?.value.trim() || '';
        const telVal = (document.getElementById('unTel')?.value.trim() || '').replace(/\s+/g, ' ');
        const ciudadVal = document.getElementById('unCiudad')?.value.trim() || '';
        const paisVal = document.getElementById('unPais')?.value || 'México';
        const patrocinadorVal = document.getElementById('unPatrocinador')?.value.trim() || '';
        const fechaVal = new Date().toISOString().substring(0, 10);

        // --- GENERACIÓN DEL PDF EN EL NAVEGADOR ---
        const htmlContrato = `
            <div style="font-family:Arial,sans-serif;max-width:800px;margin:0 auto;padding:30px;color:#222;line-height:1.6;font-size:12px;">
                <h1 style="font-size:16px;text-align:center;margin-bottom:20px;text-transform:uppercase;">Contrato mercantil de distribución</h1>
                
                <p style="text-align:justify;margin-bottom:15px;">Por medio del presente contrato se solicita a <strong>DULET INTERNATIONAL GROUP S.A. DE C.V.</strong> Su autorización para ser registrado como distribuidor independiente, en Virtud de la cual y en el caso de ser aprobado dicha solicitud, DULET INTERNATIONAL GROUP S.A. DE C.V. Le otorga el derecho no exclusivo de comprar sus productos, así como el derecho de patrocinar a posibles distribuidores para su aprobación y registro. Cualquier persona mayor de 18 años solvente puede solicitar ser un distribuidor de DULET INTERNATIONAL GROUP S.A DE C.V. En su nombre o en nombre representación de su compañía registrado.</p>

                <p style="text-align:justify;margin-bottom:20px;">Contrato mercantil de distribución que celebran por una parte, DULET INTERNATIONAL GROUP S.A. DE C.V. En carácter de vendedor, a quien en lo sucesivo se denominará Dulet o la compañía y por otra parte, en su carácter de distribuidor, el solicitante cuyo nombre aparece al anverso de este contrato y a quien en lo sucesivo se le denominará como "el distribuidor", otorgándose conforme a las siguientes declaraciones y cláusulas:</p>

                <div style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:6px;padding:15px;margin-bottom:20px;">
                    <p style="margin:4px 0;"><strong>Fecha:</strong> ${fechaVal}</p>
                    <p style="margin:4px 0;"><strong>Nombre del Distribuidor:</strong> ${nombreVal}</p>
                    <p style="margin:4px 0;"><strong>Email:</strong> ${emailVal} &nbsp;&nbsp;|&nbsp;&nbsp; <strong>Teléfono:</strong> ${telVal}</p>
                    <p style="margin:4px 0;"><strong>Dirección:</strong> ${ciudadVal}, ${paisVal}</p>
                </div>

                <h3 style="font-size:14px;margin-bottom:10px;">Declaraciones:</h3>
                
                <p style="text-align:justify;margin-bottom:10px;"><strong>1.-</strong> DULET INTERNATIONAL GROUP S.A. DE C.V., Declara de ser una sociedad constituida de acuerdo con las leyes mercantiles de la república mexicana, con domicilio en la ciudad de Zapopan, Jal, en Chimalhuacán no. 3569, planta baja, interior D, fraccionamiento ciudad del sol, CP. 45050 con R.F.C DIG201117UG4, y cuyo objeto social principal es, entre otras cosas a la venta de los productos identificados en su catálogo, que en lo sucesivo se les denominarán "LOS PRODUCTOS".</p>
                
                <p style="text-align:justify;margin-bottom:5px;"><strong>2.-</strong> Por su parte el distribuidor declara:</p>
                <p style="text-align:justify;margin-bottom:5px;padding-left:20px;">A) Que se encuentra debidamente inscrito en el registro federal de contribuyentes bajo el número de cédula indicado en la solicitud, en calidad de comerciante independiente o que se inscribirá con ese carácter en un plazo no mayor de 60 días, liberando a DULET de toda responsabilidad en caso de no hacerlo.</p>
                <p style="text-align:justify;margin-bottom:5px;padding-left:20px;">B) Que cuenta con las facultades físicas y legales para obligarse en los términos del presente contrato y que cuenta con la experiencia necesaria, así como elementos propios, para dedicarse al comercio de los productos.</p>
                <p style="text-align:justify;margin-bottom:10px;padding-left:20px;">C) Que las personas que patrocinen para ser Inscritas en el registro de distribuidores de Dulet no guardan relación familiar o laboral alguna con él ni con Dulet y tiene su mismo carácter de comerciante independiente.</p>

                <p style="text-align:justify;margin-bottom:5px;"><strong>3.-</strong> Ambas partes declaran:</p>
                <p style="text-align:justify;margin-bottom:5px;padding-left:20px;">A) que es su voluntad celebrar en este contrato, encontrándose libres de cualquier impedimento legal al momento de su firma y que la manifestación de su voluntad se ha constituido de manera libre y voluntaria, sin que existiese error, lesión, dolo, mala fe o violencia que obligase a alguna de las partes a celebrarlo, ni ignorancia de la ley en lo que concierne a los obligaciones que asumen respecto de este contrato.</p>
                <p style="text-align:justify;margin-bottom:20px;padding-left:20px;">B) que reconocen la naturaleza mercantil de la presente relación contractual y acuerdan obligarse de conformidad con las siguientes:</p>

                <h3 style="font-size:14px;margin-bottom:10px;">Cláusulas:</h3>

                <p style="text-align:justify;margin-bottom:10px;"><strong>1.-</strong> DULET, acepta vender al distribuidor sus productos a los precios de mayoreo que se encuentren vigentes a la fecha de cada uno de las compras, conforme a la lista de precios que periódicamente DULET emita. Los productos son de calidad total y solamente puede ser devueltos según la política de devolución de DULET.</p>
                
                <p style="text-align:justify;margin-bottom:10px;"><strong>2.-</strong> La adquisición de los productos a precio de mayoreo y comercialización de los mismos, representan la ganancia que el distribuidor podrá obtener de la venta.</p>
                
                <p style="text-align:justify;margin-bottom:10px;"><strong>3.-</strong> Conforme al plan de beneficios, el distribuidor tendrá derecho a obtener regalías patrocinando otros distribuidores, quienes si son aceptados por DULET pasarán a ser parte de su grupo; estas regalías se pagarán mensualmente. El distribuidor también es acreedor a obtener ciertos galardones según el plan de beneficios, estos, se pagarán en el siguiente mes de su calificación. Aceptando que las regalías serán calculadas por el número de distribuidores patrocinados que se encuentren activos durante el mes en curso. Al inverso, los galardones serán calculados según el volumen de cajas de productos y no por el número de distribuidores. Si el distribuidor no compra su caja según el plan en un mes calendario, pierde su derecho a los beneficios y regalías de ese mes.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>4.-</strong> El distribuidor líder, alcanzando una cantidad de $10,000.00 m/n en sus regalas, deberá mantener un mínimo de 5 frontales activos y en crecimiento, para tener derecho a los beneficios del plan de compensación Dulet. Ya que este sistema fue diseñado para el desarrollo y Liderazgo de todos los distribuidores activos.</p>
                
                <p style="text-align:justify;margin-bottom:10px;"><strong>5.-</strong> El distribuidor reconoce ser responsable de la supervisión y el apoyo de su grupo y se compromete a mantener comunicación y apoyo a su grupo de las juntas y dar asesoramiento sobre los productos o servicios de la compañía, siendo esto condición indispensable para el pago de sus regalías. En el caso que el distribuidor líder mantenga inactividad en el desarrollo de su red durante 2 meses continuos, se tomará como negligencia y será dado de baja.</p>
                
                <p style="text-align:justify;margin-bottom:10px;"><strong>6.-</strong> En cuanto el empresario líder Independiente logre un crecimiento de 100 cajas activas en su red durante 3 meses continuos hasta su cuarto nivel, se le invitará a formar parte como socio activo de la empresa DULET INTERNATIONAL GROUP SA. De CV. Otorgándole un bloque accionario sin costo alguno, para esto deberá de consolidar su red de mercadeo con un mínimo de 10 frontales activos en su primer nivel y estos a su vez en desarrollo.</p>
                <p style="text-align:justify;margin-bottom:10px;padding-left:20px;">A) Plan de opción de adquisición de acciones - Con el objetivo de promover e incentivar la fidelidad de los distribuidores hacia los productos Dulet en términos del presente contrato, DULET, a discreción de su órgano de administración, podrá otorgar al distribuidor la opción de adquirir acciones representativas del capital social de DULET INTERNATIONAL GROUP S.A. De C.V., Debiendo establecer las características, precio, y demás condiciones que se incluirán en cada caso en el "plan de acciones para distribuidores", el cual consiste en un documento firmado de conformidad por ambas partes.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>7.-</strong> DULET se basa en un sistema de mercadotecnia por redes de mercado, el cual da derecho al distribuidor, previo pago de la membresía de distribuir los productos únicamente en el territorio nacional. En ningún caso el distribuidor se podrá considerar como empleado, ya que no se encuadra su caso a ninguno de los supuestos normativos que establecen los artículos 8, 10 y 20 de la ley Federal del trabajo y demás relativos y similares a las normas establecidas, ni como socio, agente o franquiciatario o represente de DULET sin obtención de honorarios y sueldo, sino que percibirá solamente la utilidad de la reventa del producto y los beneficios por la(s) distribución(es) del producto(s) en su red de distribución.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>8.-</strong> Los nombres y registros de los distribuidores y clientes son propiedad de DULET y nunca serán utilizados para un propósito comercial. Un distribuidor no puede solicitar a los otros distribuidores y clientes de DULET para otra compañía de mercadotecnia por redes.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>9.-</strong> El distribuidor se obliga a no revender, exhibir los productos en tiendas, comercios, mercados o en otros lugares de venta al público sin previa autorización de DULET. El distribuidor se obliga a trabajar únicamente con el sistema de venta directa al consumidor. Los derechos del distribuidor en el presente contrato y los de su inscripción en el registro no son estrictamente personales y por lo tanto pueden ser heredados, cedidos o enajenados a otra persona física o moral con la autorización por escrito de DULET INTERNATIONAL GROUP S.A. DE C.V.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>10.-</strong> El distribuidor deberá cubrir al contado el importe de sus compras al momento en que se surta cada pedido. Si el distribuidor tiene adeudos pendientes por pedidos anteriores, DULET se reserva el derecho de abstenerse de surtir los pedidos que requiera el distribuidor. DULET se reserva el derecho de modificar o variar las reglas, porcentajes, precios y procedimientos del plan de compensación, cuando así lo considere conveniente.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>11.-</strong> En la reventa del producto al menudeo, el distribuidor se compromete ante la organización y ante los demás distribuidores a respetar los precios establecidos por la empresa y su incumplimiento será penalizado por la baja inmediata y definitiva.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>12.-</strong> El distribuidor conviene expresamente que los pedidos que haga dependerá de que DULET acepte y entregue los pedidos de productos que presente el distribuidor de acuerdo con su disponibilidad y existencia en sus almacenes. Quedando expresamente entendido que DULET no será responsable por retrasos en la entrega de los productos que se deban a una circunstancia fuera de su control o por fuerza mayor. En caso de que el distribuidor lo desee, los productos podrán ser enviados a su domicilio por un transportista o mensajería a cargo personal del distribuidor.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>13.-</strong> El distribuidor conviene que no podrá alterar, re-envasar, re-etiquetar de manera alguna cambiar producto, ni venderá los productos bajo otro nombre, marca o etiqueta distinta de la autorizada por DULET.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>14.-</strong> Queda prohibido al distribuidor y éste se obliga a no utilizar sin el consentimiento previo y por escrito de DULET, el nombre, símbolo, emblema, material y marca. El distribuidor no está autorizado a utilizar el nombre de las marcas registradas por DULET en ningún medio de publicidad incluyendo internet, panfletos, vehículos, chequera o papelería en general. El uso o reproducción parcial o total de cualquier material o marca protegida por DULET es una violación a la ley federal de la propiedad Industrial, entre otras.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>15.-</strong> DULET se reserva los derechos de autor, Intelectuales, industriales, Literarios y artísticos, relacionados con sus publicaciones, documentos, escritos, audiovisuales, por lo que el distribuidor no está autorizado para publicarlos o reproducirlos, parcial o totalmente sin el consentimiento por escrito de DULET, tampoco está autorizado a ubicar u ordenar la publicación de cualquier artículo que ilustre el concepto de ventas o cualquier material de DULET.</p>

                <p style="text-align:justify;margin-bottom:10px;"><strong>16.-</strong> Todos los gastos e Impuestos que el distribuidor realice como resultado de sus actividades, correrán bajo su más estricta responsabilidad y cuenta, en este aspecto el distribuidor se compromete a cumplir con las disposiciones legales aplicables y guardará registros de sus ventas.</p>

                <p style="text-align:justify;margin-bottom:20px;"><strong>17.-</strong> Cualquier asunto jurídico o legal relacionado con el mismo, se desahogará en los tribunales de: Guadalajara, Jalisco, México.</p>

                <div style="margin-top:50px;text-align:center;">
                    ${firmaBase64 ? `<img src="${firmaBase64}" alt="Firma digital" style="max-height:100px;border-bottom:1px solid #111;padding-bottom:5px;display:block;margin:0 auto;">` : '<div style="border-bottom:1px solid #111;width:200px;margin:0 auto 5px auto;height:50px;"></div>'}
                    <p style="font-size:12px;color:#333;margin:0;"><strong>${nombreVal}</strong><br>El Distribuidor</p>
                </div>
            </div>
        `;

        const opt = {
            margin: 10,
            filename: 'contrato.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlContrato;

        // Generar PDF y obtener Base64
        html2pdf().from(tempDiv).set(opt).outputPdf('datauristring').then(function(pdfBase64) {
            
            const payload = {
                nombre: nombreVal,
                email: emailVal,
                telefono: telVal,
                ciudad: ciudadVal,
                pais: paisVal,
                patrocinador: patrocinadorVal,
                firma_base64: firmaBase64,
                pdf_base64: pdfBase64.includes(',') ? pdfBase64.split(',')[1] : pdfBase64,  // <-- Nuevo campo con el PDF listo en binario Base64
                fecha_contrato: fechaVal
            };
            
            // Envío a n8n
            fetch('https://n8n.duletias3rver.com/webhook/web/unete-ahora', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
            .then(r => r.json())
            .then(data => {
                document.getElementById('uneteSpinner').style.display = 'none';
                if (data.ok) {
                    document.getElementById('uneteResultOk').style.display = 'block';
                    document.getElementById('uneteRegistroResult').textContent = '#' + data.registro;
                } else {
                    document.getElementById('uneteResultError').style.display = 'block';
                    document.getElementById('uneteErrorMsg').textContent = data.error || data.message || 'Error al procesar tu registro. Por favor intenta de nuevo.';
                }
            })
            .catch(err => {
                document.getElementById('uneteSpinner').style.display = 'none';
                document.getElementById('uneteResultError').style.display = 'block';
                document.getElementById('uneteErrorMsg').textContent = 'Error de conexión. Verifica tu internet e intenta de nuevo.';
            });
        }).catch(e => {
            console.error('Error generando PDF:', e);
            document.getElementById('uneteSpinner').style.display = 'none';
            document.getElementById('uneteResultError').style.display = 'block';
            document.getElementById('uneteErrorMsg').textContent = 'Error al generar tu contrato digital.';
        });
    }
}

function uneteBack(from) {
    if (from === 2) { _uneteStep = 1; _updateUneteUI(); }
}

// ---- Firma Canvas ----
function _initFirmaCanvas() {
    const canvas = document.getElementById('uneteFirmaCanvas');
    if (!canvas) return;
    _firmaCtx = canvas.getContext('2d');
    // Set canvas resolution to match CSS size
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * (window.devicePixelRatio || 1);
    canvas.height = rect.height * (window.devicePixelRatio || 1);
    _firmaCtx.scale(window.devicePixelRatio || 1, window.devicePixelRatio || 1);
    _firmaCtx.strokeStyle = '#3B82F6';
    _firmaCtx.lineWidth = 2.5;
    _firmaCtx.lineCap = 'round';
    _firmaCtx.lineJoin = 'round';
    _firmaVacia = true;

    const getPos = (e) => {
        const r = canvas.getBoundingClientRect();
        if (e.touches) return { x: e.touches[0].clientX - r.left, y: e.touches[0].clientY - r.top };
        return { x: e.clientX - r.left, y: e.clientY - r.top };
    };

    const startDraw = (e) => { e.preventDefault(); _firmaDibujando = true; _firmaVacia = false; const p = getPos(e); _firmaCtx.beginPath(); _firmaCtx.moveTo(p.x, p.y); };
    const draw = (e) => { if (!_firmaDibujando) return; e.preventDefault(); const p = getPos(e); _firmaCtx.lineTo(p.x, p.y); _firmaCtx.stroke(); };
    const stopDraw = () => { _firmaDibujando = false; };

    canvas.addEventListener('mousedown', startDraw);
    canvas.addEventListener('mousemove', draw);
    canvas.addEventListener('mouseup', stopDraw);
    canvas.addEventListener('mouseleave', stopDraw);
    canvas.addEventListener('touchstart', startDraw, { passive: false });
    canvas.addEventListener('touchmove', draw, { passive: false });
    canvas.addEventListener('touchend', stopDraw);
}

// ---- 14. DEEP LINK — #unete abre el modal automáticamente ----
(function initDeepLink() {
    const tryOpen = () => {
        if (window.location.hash === '#unete') {
            // Espera a que el DOM esté listo y el overlay exista
            if (document.getElementById('uneteOverlay')) {
                openUneteModal();
                // Limpia el hash sin recargar la página
                history.replaceState(null, '', window.location.pathname + window.location.search);
            } else {
                // Si el overlay aún no existe, reintenta en 300ms
                setTimeout(tryOpen, 300);
            }
        }
    };
    // Al cargar la página
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', tryOpen);
    } else {
        tryOpen();
    }
    // También reacciona si el hash cambia en runtime (navegación interna)
    window.addEventListener('hashchange', tryOpen);
})();

function uneteClearFirma() {
    const canvas = document.getElementById('uneteFirmaCanvas');
    if (!canvas || !_firmaCtx) return;
    _firmaCtx.clearRect(0, 0, canvas.width, canvas.height);
    _firmaVacia = true;
}

function uneteDescargarPDF() {
    // Use the contract content to generate a simple printable page
    const nombre = document.getElementById('unNombre')?.value || '';
    const email = document.getElementById('unEmail')?.value || '';
    const tel = document.getElementById('unTel')?.value || '';
    const ciudad = document.getElementById('unCiudad')?.value || '';
    const pais = document.getElementById('unPais')?.value || 'México';
    const fecha = document.getElementById('contratoFecha')?.textContent || '';
    const canvas = document.getElementById('uneteFirmaCanvas');
    const firmaImg = canvas ? canvas.toDataURL('image/png') : '';

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Contrato Dulet - ${nombre}</title>
    <style>
    body{font-family:Arial,sans-serif;max-width:800px;margin:20px auto;color:#222;line-height:1.6;font-size:12px;padding:20px;}
    .header-box { text-align: center; margin-bottom: 20px; border-bottom: 2px solid #ce283c; padding-bottom: 10px; }
    .header-box img { max-height: 60px; }
    h1{font-size:16px;text-align:center;margin:10px 0;text-transform:uppercase;color:#ce283c;}
    .data{background:#f9fafb;border:1px solid #e5e7eb;border-radius:6px;padding:15px;margin-bottom:20px;}
    .data p{margin:4px 0;font-size:13px;}
    h3{font-size:14px;margin-bottom:10px;color:#111;text-transform:uppercase;}
    p{text-align:justify;margin-bottom:10px;}
    .firma{margin-top:50px;text-align:center;}
    .firma img{max-height:100px;border-bottom:1px solid #111;padding-bottom:5px;display:block;margin:0 auto;}
    .firma-linea{border-bottom:1px solid #111;width:200px;margin:0 auto 5px auto;height:50px;}
    .firma p{font-size:12px;color:#333;margin:0;font-weight:bold;}
    @media print{body{margin:0;padding:15px;}}
    </style></head><body>

    <div class="header-box">
        <img src="images/dulet_logo.png" alt="Dulet Logo">
        <h1>Contrato mercantil de distribución</h1>
    </div>
    
    <p>Por medio del presente contrato se solicita a <strong>DULET INTERNATIONAL GROUP S.A. DE C.V.</strong> Su autorización para ser registrado como distribuidor independiente, en Virtud de la cual y en el caso de ser aprobado dicha solicitud, DULET INTERNATIONAL GROUP S.A. DE C.V. Le otorga el derecho no exclusivo de comprar sus productos, así como el derecho de patrocinar a posibles distribuidores para su aprobación y registro. Cualquier persona mayor de 18 años solvente puede solicitar ser un distribuidor de DULET INTERNATIONAL GROUP S.A DE C.V. En su nombre o en nombre representación de su compañía registrado.</p>

    <p>Contrato mercantil de distribución que celebran por una parte, DULET INTERNATIONAL GROUP S.A. DE C.V. En carácter de vendedor, a quien en lo sucesivo se denominará Dulet o la compañía y por otra parte, en su carácter de distribuidor, el solicitante cuyo nombre aparece al anverso de este contrato y a quien en lo sucesivo se le denominará como "el distribuidor", otorgándose conforme a las siguientes declaraciones y cláusulas:</p>

    <div class="data">
        <p><strong>Fecha:</strong> ${fecha}</p>
        <p><strong>Nombre del Distribuidor:</strong> ${nombre}</p>
        <p><strong>Email:</strong> ${email} &nbsp;&nbsp;|&nbsp;&nbsp; <strong>Teléfono:</strong> ${tel}</p>
        <p><strong>Dirección:</strong> ${ciudad}, ${pais}</p>
    </div>

    <h3>Declaraciones:</h3>
    <p><strong>1.-</strong> DULET INTERNATIONAL GROUP S.A. DE C.V., Declara de ser una sociedad constituida de acuerdo con las leyes mercantiles de la república mexicana, con domicilio en la ciudad de Zapopan, Jal, en Chimalhuacán no. 3569, planta baja, interior D, fraccionamiento ciudad del sol, CP. 45050 con R.F.C DIG201117UG4, y cuyo objeto social principal es, entre otras cosas a la venta de los productos identificados en su catálogo, que en lo sucesivo se les denominarán "LOS PRODUCTOS".</p>
    <p style="margin-bottom:5px;"><strong>2.-</strong> Por su parte el distribuidor declara:</p>
    <p style="padding-left:20px;margin-bottom:5px;">A) Que se encuentra debidamente inscrito en el registro federal de contribuyentes bajo el número de cédula indicado en la solicitud, en calidad de comerciante independiente o que se inscribirá con ese carácter en un plazo no mayor de 60 días, liberando a DULET de toda responsabilidad en caso de no hacerlo.</p>
    <p style="padding-left:20px;margin-bottom:5px;">B) Que cuenta con las facultades físicas y legales para obligarse en los términos del presente contrato y que cuenta con la experiencia necesaria, así como elementos propios, para dedicarse al comercio de los productos.</p>
    <p style="padding-left:20px;margin-bottom:10px;">C) Que las personas que patrocinen para ser Inscritas en el registro de distribuidores de Dulet no guardan relación familiar o laboral alguna con él ni con Dulet y tiene su mismo carácter de comerciante independiente.</p>
    <p style="margin-bottom:5px;"><strong>3.-</strong> Ambas partes declaran:</p>
    <p style="padding-left:20px;margin-bottom:5px;">A) que es su voluntad celebrar en este contrato, encontrándose libres de cualquier impedimento legal al momento de su firma y que la manifestación de su voluntad se ha constituido de manera libre y voluntaria, sin que existiese error, lesión, dolo, mala fe o violencia que obligase a alguna de las partes a celebrarlo, ni ignorancia de la ley en lo que concierne a los obligaciones que asumen respecto de este contrato.</p>
    <p style="padding-left:20px;margin-bottom:20px;">B) que reconocen la naturaleza mercantil de la presente relación contractual y acuerdan obligarse de conformidad con las siguientes:</p>

    <h3>Cláusulas:</h3>
    <p><strong>1.-</strong> DULET, acepta vender al distribuidor sus productos a los precios de mayoreo que se encuentren vigentes a la fecha de cada uno de las compras, conforme a la lista de precios que periódicamente DULET emita. Los productos son de calidad total y solamente puede ser devueltos según la política de devolución de DULET.</p>
    <p><strong>2.-</strong> La adquisición de los productos a precio de mayoreo y comercialización de los mismos, representan la ganancia que el distribuidor podrá obtener de la venta.</p>
    <p><strong>3.-</strong> Conforme al plan de beneficios, el distribuidor tendrá derecho a obtener regalías patrocinando otros distribuidores, quienes si son aceptados por DULET pasarán a ser parte de su grupo; estas regalías se pagarán mensualmente. El distribuidor también es acreedor a obtener ciertos galardones según el plan de beneficios, estos, se pagarán en el siguiente mes de su calificación. Aceptando que las regalías serán calculadas por el número de distribuidores patrocinados que se encuentren activos durante el mes en curso. Al inverso, los galardones serán calculados según el volumen de cajas de productos y no por el número de distribuidores. Si el distribuidor no compra su caja según el plan en un mes calendario, pierde su derecho a los beneficios y regalías de ese mes.</p>
    <p><strong>4.-</strong> El distribuidor líder, alcanzando una cantidad de $10,000.00 m/n en sus regalas, deberá mantener un mínimo de 5 frontales activos y en crecimiento, para tener derecho a los beneficios del plan de compensación Dulet. Ya que este sistema fue diseñado para el desarrollo y Liderazgo de todos los distribuidores activos.</p>
    <p><strong>5.-</strong> El distribuidor reconoce ser responsable de la supervisión y el apoyo de su grupo y se compromete a mantener comunicación y apoyo a su grupo de las juntas y dar asesoramiento sobre los productos o servicios de la compañía, siendo esto condición indispensable para el pago de sus regalías. En el caso que el distribuidor líder mantenga inactividad en el desarrollo de su red durante 2 meses continuos, se tomará como negligencia y será dado de baja.</p>
    <p><strong>6.-</strong> En cuanto el empresario líder Independiente logre un crecimiento de 100 cajas activas en su red durante 3 meses continuos hasta su cuarto nivel, se le invitará a formar parte como socio activo de la empresa DULET INTERNATIONAL GROUP SA. De CV. Otorgándole un bloque accionario sin costo alguno, para esto deberá de consolidar su red de mercadeo con un mínimo de 10 frontales activos en su primer nivel y estos a su vez en desarrollo.</p>
    <p style="padding-left:20px;">A) Plan de opción de adquisición de acciones - Con el objetivo de promover e incentivar la fidelidad de los distribuidores hacia los productos Dulet en términos del presente contrato, DULET, a discreción de su órgano de administración, podrá otorgar al distribuidor la opción de adquirir acciones representativas del capital social de DULET INTERNATIONAL GROUP S.A. De C.V., Debiendo establecer las características, precio, y demás condiciones que se incluirán en cada caso en el "plan de acciones para distribuidores", el cual consiste en un documento firmado de conformidad por ambas partes.</p>
    <p><strong>7.-</strong> DULET se basa en un sistema de mercadotecnia por redes de mercado, el cual da derecho al distribuidor, previo pago de la membresía de distribuir los productos únicamente en el territorio nacional. En ningún caso el distribuidor se podrá considerar como empleado, ya que no se encuadra su caso a ninguno de los supuestos normativos que establecen los artículos 8, 10 y 20 de la ley Federal del trabajo y demás relativos y similares a las normas establecidas, ni como socio, agente o franquiciatario o represente de DULET sin obtención de honorarios y sueldo, sino que percibirá solamente la utilidad de la reventa del producto y los beneficios por la(s) distribución(es) del producto(s) en su red de distribución.</p>
    <p><strong>8.-</strong> Los nombres y registros de los distribuidores y clientes son propiedad de DULET y nunca serán utilizados para un propósito comercial. Un distribuidor no puede solicitar a los otros distribuidores y clientes de DULET para otra compañía de mercadotecnia por redes.</p>
    <p><strong>9.-</strong> El distribuidor se obliga a no revender, exhibir los productos en tiendas, comercios, mercados o en otros lugares de venta al público sin previa autorización de DULET. El distribuidor se obliga a trabajar únicamente con el sistema de venta directa al consumidor. Los derechos del distribuidor en el presente contrato y los de su inscripción en el registro no son estrictamente personales y por lo tanto pueden ser heredados, cedidos o enajenados a otra persona física o moral con la autorización por escrito de DULET INTERNATIONAL GROUP S.A. DE C.V.</p>
    <p><strong>10.-</strong> El distribuidor deberá cubrir al contado el importe de sus compras al momento en que se surta cada pedido. Si el distribuidor tiene adeudos pendientes por pedidos anteriores, DULET se reserva el derecho de abstenerse de surtir los pedidos que requiera el distribuidor. DULET se reserva el derecho de modificar o variar las reglas, porcentajes, precios y procedimientos del plan de compensación, cuando así lo considere conveniente.</p>
    <p><strong>11.-</strong> En la reventa del producto al menudeo, el distribuidor se compromete ante la organización y ante los demás distribuidores a respetar los precios establecidos por la empresa y su incumplimiento será penalizado por la baja inmediata y definitiva.</p>
    <p><strong>12.-</strong> El distribuidor conviene expresamente que los pedidos que haga dependerá de que DULET acepte y entregue los pedidos de productos que presente el distribuidor de acuerdo con su disponibilidad y existencia en sus almacenes. Quedando expresamente entendido que DULET no será responsable por retrasos en la entrega de los productos que se deban a una circunstancia fuera de su control o por fuerza mayor. En caso de que el distribuidor lo desee, los productos podrán ser enviados a su domicilio por un transportista o mensajería a cargo personal del distribuidor.</p>
    <p><strong>13.-</strong> El distribuidor conviene que no podrá alterar, re-envasar, re-etiquetar de manera alguna cambiar producto, ni venderá los productos bajo otro nombre, marca o etiqueta distinta de la autorizada por DULET.</p>
    <p><strong>14.-</strong> Queda prohibido al distribuidor y éste se obliga a no utilizar sin el consentimiento previo y por escrito de DULET, el nombre, símbolo, emblema, material y marca. El distribuidor no está autorizado a utilizar el nombre de las marcas registradas por DULET en ningún medio de publicidad incluyendo internet, panfletos, vehículos, chequera o papelería en general. El uso o reproducción parcial o total de cualquier material o marca protegida por DULET es una violación a la ley federal de la propiedad Industrial, entre otras.</p>
    <p><strong>15.-</strong> DULET se reserva los derechos de autor, Intelectuales, industriales, Literarios y artísticos, relacionados con sus publicaciones, documentos, escritos, audiovisuales, por lo que el distribuidor no está autorizado para publicarlos o reproducirlos, parcial o totalmente sin el consentimiento por escrito de DULET, tampoco está autorizado a ubicar u ordenar la publicación de cualquier artículo que ilustre el concepto de ventas o cualquier material de DULET.</p>
    <p><strong>16.-</strong> Todos los gastos e Impuestos que el distribuidor realice como resultado de sus actividades, correrán bajo su más estricta responsabilidad y cuenta, en este aspecto el distribuidor se compromete a cumplir con las disposiciones legales aplicables y guardará registros de sus ventas.</p>
    <p style="margin-bottom:30px;"><strong>17.-</strong> Cualquier asunto jurídico o legal relacionado con el mismo, se desahogará en los tribunales de: Guadalajara, Jalisco, México.</p>

    <div class="firma">
        ${firmaImg ? `<img src="${firmaImg}" alt="Firma digital">` : '<div class="firma-linea"></div>'}
        <p>${nombre}<br>El Distribuidor</p>
    </div>
    </body></html>`;

    const w = window.open('', '_blank');
    if (w) {
        w.document.write(html);
        w.document.close();
        setTimeout(() => w.print(), 500);
    }
}

// ---- 19. MOBILE DRAWER V2 ----
(function initMobileDrawerV2() {
    const btn = document.getElementById('mobileMenuBtn');
    const drawer = document.getElementById('mobileDrawerV2');
    const overlay = document.getElementById('mobileDrawerOverlay');
    const closeBtn = document.getElementById('mobileDrawerCloseBtn');
    const links = document.querySelectorAll('.mobile-link');

    if (!btn || !drawer || !overlay) return;

    function openDrawer() {
        drawer.classList.add('open');
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        drawer.classList.remove('open');
        overlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    window.closeMobileDrawer = closeDrawer;

    btn.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    links.forEach(link => {
        link.addEventListener('click', closeDrawer);
    });
})();
